import { ChangeEvent, FC } from "react"
import classNames from "classnames"
import Cell from "./Cell"
import TextField from "./TextField"
import TimezoneCell from "./TimezoneCell"
import { fieldConfig } from "@/pages/ControlPanel/config"
import { Facility, FacilityAddress, FacilityForm } from "@/types/facility"
import { convertCamelToKebab } from "@/utils/index"
import { get, isNull, isUndefined } from "@/utils/lodash"

export const AddressInfo: FC<{
   id: Facility["id"]
   isEditMode: boolean
   address: FacilityAddress
   onChange: (e: ChangeEvent<HTMLInputElement>) => void
   onStateChange: (selectedState: string) => void
   onTimezoneChange: (timezone: FacilityAddress["timezone"]) => void
   facilityFormState?: Facility | FacilityForm
   showCountry?: boolean
}> = ({
   isEditMode,
   address,
   onChange,
   onStateChange,
   onTimezoneChange,
   facilityFormState,
   showCountry = false,
}) => {
   const { country, state, city, street, zipCode, timezone } = address
   const stateAddress = get(facilityFormState, "address", {} as FacilityAddress)

   return (
      <>
         {Object.entries({
            ...(showCountry ? { country } : {}),
            state,
            city,
            street,
            zipCode,
         }).map(([key, value], index) => {
            const placeholder =
               fieldConfig[key as keyof FacilityAddress]?.placeholder
            const isValid = isNull(value)
               ? true
               : fieldConfig[key as keyof FacilityAddress]?.validate(
                    stateAddress[key as keyof FacilityAddress] ?? value
                 )
            return (
               <span
                  key={`${key}-${index}`}
                  className={classNames(
                     `customers-facilities-table__facility-address-info-${convertCamelToKebab(key)}`
                  )}
               >
                  <Cell
                     name={key}
                     value={
                        stateAddress[key as keyof FacilityAddress] ??
                        (value || "")
                     }
                     isEditMode={isEditMode}
                     handleCellChange={(e) => {
                        if ((key as keyof FacilityAddress) === "state") {
                           return onStateChange(e.target.value)
                        }
                        return onChange(e)
                     }}
                     placeholder={placeholder}
                     {...(value !== "" && {
                        error: !isValid,
                     })}
                  >
                     <TextField name={key as keyof FacilityAddress}>
                        {value}
                     </TextField>
                  </Cell>
               </span>
            )
         })}
         <span className="customers-facilities-table__facility-address-info-timezone">
            <TimezoneCell
               value={
                  isUndefined(stateAddress.timezone)
                     ? timezone
                     : stateAddress.timezone
               }
               isEditMode={isEditMode}
               onChange={onTimezoneChange}
            />
         </span>
      </>
   )
}
